import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import { QuestionType } from '../../../../commons/EditorStatus'
import { Type } from '../EditProblem/EditProblem'
import EditProblemItem from '../EditProblemItem/EditProblemItem'
import TextLabel, { SizeType, WeightType } from '../../atoms/TextLabel/TextLabel'
import EditChoice from '../../organisms/EditChoice/EditChoice'
import EditorImageUploadModal from '../EditorImageUploadModal/EditorImageUploadModal'
import './EditChoiceSet.css'

const EditChoiceSet = ({
  choiceSet,
  saveImageInStore,
  deleteImage,
  answerChoiceId,
  onChangeAnswerChoice,
  onChangeQuestionType,
  onChangeChoiceTitle,
  selectedQuestionType,
  questionTypeCandidate,
  showImageUploadModal,
  hideImageUploadModal,
  isModalShow,
  imageUploadTargetIndex,
  choiceImageErrorMessage
}) => {
  const questionTypeSelection = (
    <EditProblemItem
      idx="0"
      itemType={Type.DROPDOWN}
      problemTitle="種類"
      contents={questionTypeCandidate}
      onChangeProblemContent={onChangeQuestionType}
      selectedValue={selectedQuestionType}
    />
  )

  const trueForceTitles = ['マル', 'バツ']
  const showRadioButton = QuestionType.REALTIME.value !== selectedQuestionType
  const choices = choiceSet.map((choice, choiceIndex) => {
    // answerChoiceIdがあるところのindex
    const answerChoiceIdIndex = choiceSet.findIndex(({ id }) => id === answerChoiceId)
    let choiceText
    if (QuestionType.TRUEFALSE.value === selectedQuestionType) {
      choiceText = trueForceTitles[choiceIndex]
    } else {
      choiceText = choice.title
    }
    return (
      <div key={`edit-choice-${choiceIndex}`} styleName="choice-item">
        <EditChoice
          index={choiceIndex}
          choiceText={choiceText}
          answerChoiceId={answerChoiceIdIndex}
          choiceImage={choice.image}
          onChangeChoiceText={onChangeChoiceTitle}
          onChangeAnswerChoice={onChangeAnswerChoice}
          toggleImageUploadModal={showImageUploadModal}
          selectedQuestionType={selectedQuestionType}
          showRadioButton={showRadioButton}
        />
      </div>
    )
  })
  return (
    <div styleName="container">
      {questionTypeSelection}
      <p styleName="title">選択肢</p>
      {showRadioButton ? null : (
        <TextLabel size={SizeType.XXTINY} weight={WeightType.LIGHT}>
          回答集計後にその場で正解を決定できます
        </TextLabel>
      )}
      <div styleName="choice-set">{choices}</div>
      <EditorImageUploadModal
        isModalShow={isModalShow}
        imageUrl={(choiceSet[imageUploadTargetIndex] || {}).image}
        handleModal={() => hideImageUploadModal()}
        targetIndex={imageUploadTargetIndex}
        onChangeImage={saveImageInStore}
        onDeleteImage={deleteImage}
        errorMessage={choiceImageErrorMessage}
      />
    </div>
  )
}

EditChoiceSet.propTypes = {
  choiceSet: PropTypes.array,
  onChangeChoiceTitle: PropTypes.func,
  answerChoiceId: PropTypes.number,
  saveImageInStore: PropTypes.func,
  deleteImage: PropTypes.func,
  onChangeAnswerChoice: PropTypes.func,
  onChangeQuestionType: PropTypes.func,
  selectedQuestionType: PropTypes.number,
  questionTypeCandidate: PropTypes.array,
  showImageUploadModal: PropTypes.func,
  hideImageUploadModal: PropTypes.func,
  isModalShow: PropTypes.bool,
  imageUploadTargetIndex: PropTypes.number,
  choiceImageErrorMessage: PropTypes.string
}

export default compose(pure)(EditChoiceSet)
